import React from "react";
import "./scrollCards.css";
import { FaStar, FaArrowRight, FaArrowLeft } from "react-icons/fa";
import ScrollCardsInfo from "../ScrollCardsInfo/scrollCardsInfo";

const ScrollCards = () => {
  const Rightscrol = () => {
    document.getElementById("containe").scrollLeft += 430;
  };
  const Leftscrol = () => {
    document.getElementById("containe").scrollLeft -= 430;
  };

  return (
    <>
    <div className="scroll-cards-top-pad ">
      <div><h3 className="mindmap-heading">The Mindmap:</h3>

      </div>
      <div className="tes-card" id="containe">

        <button onClick={Leftscrol} className="tes-btn">
          <FaArrowLeft size={22.5} />
        </button>
        <button onClick={Rightscrol} className="tes-btn1">
          <FaArrowRight size={22.5} />
        </button>

        <div className=" scroll-cards-style">
          <ScrollCardsInfo
            headingOne="Lorem Ipsum "
            contentOne="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentTwo="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentThree="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            // contentFour="Which HYPERSLOTH are you hoping for?"
          />
          <ScrollCardsInfo
            headingOne="Lorem Ipsum "
            contentOne="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentTwo="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentThree="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
          />
          <ScrollCardsInfo
            headingOne="Lorem Ipsum "
            contentOne="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentTwo="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentThree="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
          />
          <ScrollCardsInfo
            headingOne="Lorem Ipsum "
            contentOne="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentTwo="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentThree="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
          />
          <ScrollCardsInfo
            headingOne="Lorem Ipsum "
            contentOne="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentTwo="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentThree="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
          />
          <ScrollCardsInfo
            headingOne="Lorem Ipsum "
            contentOne="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentTwo="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            contentThree="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
          />
        </div>
      </div>
      </div>
    </>
  );
};
export default ScrollCards;
